import { useFloatingTree, useMergeRefs } from '@floating-ui/react';
import { Close } from '@interhyp/platform-icons';
import { arrowLeft } from '@platform/icons';
import classnames from 'classnames';
import React, { useContext, useRef } from 'react';
import { IconButton } from "../../../iconButton/IconButton.js";
import { InputSearch } from "../../../inputSearch/InputSearch.js";
import { Typography } from "../../../typography/Typography.js";
import { MenuContext } from "../../context/MenuContext.js";
import { SearchContext } from "../../context/SearchContext.js";
import { SettingsContext } from "../../context/SettingsContext.js";
import { useInputKeyDownHandling } from "../../hooks/useInputKeyDownHandling.js";
import { useMobileCheck } from "../../hooks/useMobileCheck.js";
import styles from "./ContextMenuColumnTop.module.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function ContextMenuColumnTop({
  label,
  showSearchInput,
  level
}) {
  const inputRef = useRef(null);
  const {
    refs,
    getReferenceProps,
    setIsOpen
  } = useContext(MenuContext);
  const {
    searchString,
    setSearchString
  } = useContext(SearchContext);
  const {
    inputPlaceholder = 'Suchbegriff eingeben...'
  } = useContext(SettingsContext);
  const isMobile = useMobileCheck();
  const tree = useFloatingTree();
  const inputRefs = useMergeRefs([refs?.setReference, inputRef]);
  const {
    onKeyDown
  } = getReferenceProps();
  const inputKeyDown = useInputKeyDownHandling(onKeyDown);
  return /*#__PURE__*/_jsxs("div", {
    className: classnames(styles.columnTop, showSearchInput && styles.columnTopWithSearch),
    children: [showSearchInput && /*#__PURE__*/_jsx(InputSearch, {
      inputRef: inputRefs ?? undefined,
      placeholder: inputPlaceholder,
      value: searchString,
      role: "combobox",
      "aria-autocomplete": "list",
      onChange: e => {
        setSearchString(e.target.value);
      },
      onClear: () => setSearchString(''),
      onKeyDown: inputKeyDown,
      className: styles.search
    }), isMobile && /*#__PURE__*/_jsxs("div", {
      className: styles.mobileTop,
      children: [level > 0 && /*#__PURE__*/_jsx(IconButton, {
        title: "Zur\xFCck",
        className: styles.backBtn,
        tertiary: true,
        onClick: () => setIsOpen(false),
        icon: arrowLeft,
        small: true
      }), /*#__PURE__*/_jsx(Typography, {
        margin: false,
        className: styles.label,
        variant: "strong",
        children: label
      }), /*#__PURE__*/_jsx(IconButton, {
        title: "Schlie\xDFen",
        className: styles.closeBtn,
        tertiary: true,
        onClick: () => tree?.events.emit('click'),
        small: true,
        children: /*#__PURE__*/_jsx(Close, {})
      })]
    })]
  });
}